<template>
  <div>
    <!-- <div class="c-select-overlay" :class="{ 'c-select-overlay_active': container }" @click="closeContainer"></div> -->
    <div
      ref="select"
      class="c-select"
      :class="{
        'c-select_size_small': size === 'small',
        'invalid': invalid,
      }"
    >
      <div
        class="c-select__wrapper"
        :class="{
          'c-select__wrapper_with-label': label,
        }"
      >
        <div v-if="label" class="c-select__label">
          {{ label }}
          <span v-if="requiredMark" class="c-select__label__required">*</span>
        </div>

        <div v-if="floatingLabel" class="c-select-floating-label-not-visible">
          {{ floatingLabel }}
        </div>

        <div
          v-if="floatingLabel"
          class="c-select-floating-label"
          :class="{
            'c-select-floating-label-active':
              (isArray(localValue) && localValue.length !== 0) || (!isArray(localValue) && localValue),
          }"
        >
          {{ floatingLabel }}
          <span v-if="requiredMark" class="c-select__label__required">*</span>
        </div>

        <button
          ref="input"
          class="c-select__input"
          :class="{
            'c-select__input_empty': multiple && (!localValue || localValue.length === 0),
            'c-select__input_required': !multiple && required,
          }"
          type="button"
        >
          <div v-if="!multiple" class="c-select__value" @click="openContainer">
            <template v-if="localValue">
              <template v-if="localValue.resultLabel">
                <span v-html="localValue.resultLabel"></span>
              </template>
              <template v-else>
                <span>{{ localValue.label || getLabel(localValue) }}</span>
              </template>
            </template>
          </div>

          <div v-if="multiple" class="c-select__value c-select__value_multiple" @click="openContainer">
            <div
              v-for="valueItem in localValue"
              :key="valueItem.value"
              class="c-select__value-item"
              :style="{
                backgroundColor: useCustomColors && valueItem.backgroundColor ? valueItem.backgroundColor : '#fff',
              }"
            >
              <div class="c-select__value-item-label">
                <template v-if="valueItem.resultLabel">
                  <span v-html="valueItem.resultLabel"></span>
                </template>
                <template v-else>
                  <span>{{ localValue.label || getLabel(valueItem) }}</span>
                </template>
              </div>

              <div class="c-select__value-item-close" @click.stop="dropItem(valueItem)">
                <svg width="12" height="12" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.525425 11.6783C0.94995 12.1016 1.63824 12.1016 2.06277 11.6783L11.8886 1.88173C12.3132 1.45841 12.3132 0.772068 11.8886 0.348743C11.4641 -0.0745802 10.7758 -0.0745802 10.3513 0.348743L0.525425 10.1453C0.100901 10.5686 0.100901 11.255 0.525425 11.6783Z"
                  />
                  <path
                    d="M0.593335 0.450393C1.01786 0.0270681 1.70615 0.0270681 2.13068 0.450393L11.8886 10.1808C12.3132 10.6041 12.3132 11.2904 11.8886 11.7138C11.4641 12.1371 10.7758 12.1371 10.3513 11.7138L0.593335 1.98338C0.168811 1.56006 0.168811 0.873716 0.593335 0.450393Z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div v-if="placeholder && (!localValue || localValue.length === 0)" class="c-select__placeholder">
            {{ placeholder }}
          </div>

          <div
            v-if="clearable"
            class="c-select__clear"
            :class="{ 'c-select__clear_hidden': !localValue }"
            @click="clear"
          >
            <svg width="12" height="12" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.525425 11.6783C0.94995 12.1016 1.63824 12.1016 2.06277 11.6783L11.8886 1.88173C12.3132 1.45841 12.3132 0.772068 11.8886 0.348743C11.4641 -0.0745802 10.7758 -0.0745802 10.3513 0.348743L0.525425 10.1453C0.100901 10.5686 0.100901 11.255 0.525425 11.6783Z"
              />
              <path
                d="M0.593335 0.450393C1.01786 0.0270681 1.70615 0.0270681 2.13068 0.450393L11.8886 10.1808C12.3132 10.6041 12.3132 11.2904 11.8886 11.7138C11.4641 12.1371 10.7758 12.1371 10.3513 11.7138L0.593335 1.98338C0.168811 1.56006 0.168811 0.873716 0.593335 0.450393Z"
              />
            </svg>
          </div>

          <div v-if="!checkbox" class="c-select__icon" @click="openContainer">
            <c-icon icon="arrow" />
          </div>

          <div v-if="reverse !== undefined" class="c-select__reverse">
            <c-switcher
              v-if="!reverseType"
              v-model="localReverse"
              class="c-select__reverse-switcher"
              :disabled="!value || value.length === 0"
              label="Все кроме"
              type="checkbox"
              @mousedown="mousedownReverse"
            />
            <c-switcher
              v-if="reverseType === 'icon'"
              v-model="localReverse"
              type="checkbox-icon"
              :disabled="!localValue || localValue && localValue.length === 0"
              :tooltip="reverseTooltip"
              @mousedown="mousedownReverse"
            />
          </div>
          <div
            v-if="checkbox"
            class="c-select-checkbox"
            :class="{ 'c-select-checkbox-type-icon': checkboxType === 'icon' }"
          >
            <c-switcher
              v-if="checkboxType === 'icon'"
              v-model="checkboxValueLocal"
              type="checkbox-icon"
              :disabled="!value || value.length === 0"
              :tooltip="checkboxTooltip"
            />
          </div>
        </button>

        <div v-if="required && !multiple" class="c-select-required c-select-required_active">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
            <circle cx="7" cy="10" r="1" fill="#FF238D" />
            <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
          </svg>

          <div class="c-select-required-text">{{ required }}</div>
        </div>

        <div
          v-if="items"
          ref="container"
          class="c-select__container"
          :class="{ 'c-select__container_active': container }"
        >
          <div v-if="showSearch" class="c-select__search">
            <div class="c-select__search-icon">
              <svg width="13" height="13" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4142 11L15.6569 15.2426M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>

            <input ref="searchInput" v-model="query" type="text" class="c-select__search-input" placeholder="Поиск" />

            <transition name="fade">
              <div v-if="query" class="c-select__search-clear" @click="resetSearch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z"
                    fill="#FF238D"
                  />
                  <path
                    d="M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z"
                    fill="#FF238D"
                  />
                </svg>
              </div>
            </transition>
          </div>

          <div ref="list" class="c-select__list">
            <div v-if="!filteredGroups.length">
              <div class="c-select__empty">
                {{ emptyMessage }}
              </div>
            </div>

            <div v-for="group in filteredGroups" :key="group.id" class="c-select__group" :data-group="group.id">
              <div
                v-if="group.label"
                class="c-select__group-label"
                :style="{ color: useCustomColors && group.color ? group.color : '' }"
              >
                <span v-html="group.label"></span>
              </div>

              <div class="c-select__group-items">
                <div
                  v-for="item in group.items"
                  :key="item.value"
                  class="c-select__item"
                  :class="{
                    'c-select__item_selected': isItemSelected(item),
                    'c-select__item_disabled': isItemDisabled(item),
                  }"
                  @click="(e) => selectItem(item)"
                >
                  <div class="c-select__item-label">
                    <template v-if="item.formatLabel">
                      <span v-html="item.formatLabel"></span>
                    </template>
                    <template v-else>
                      <span>{{ item.label || getLabel(item) }}</span>
                    </template>

                    <div v-if="item.subLabel" class="c-select__item-sublabel">
                      {{ item.subLabel }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="multiple" class="c-select__group-items-mobile">
                <c-switcher
                  v-for="item in group.items"
                  :id="item.value"
                  :key="`switcher-item-${item.value}`"
                  v-model="checkedMobileMultipleSelects"
                  class="c-select__item__mobile"
                  :label="{
                    text: item.formatLabel || item.label,
                    color: null,
                  }"
                  type="checkbox"
                  :value="item"
                  :checked="item"
                  :multi="true"
                  :nowrap="true"
                />
              </div>

              <div v-else class="c-select__group-items-mobile">
                <div
                  v-for="item in group.items"
                  :key="item.value"
                  class="c-select__item"
                  :class="{
                    'c-select__item_selected': isItemSelected(item),
                    'c-select__item_disabled': isItemDisabled(item),
                  }"
                  @click="(e) => selectItem(item)"
                >
                  <div class="c-select__item-label">
                    {{ item.label }}
                    <div v-if="item.subLabel" class="c-select__item-sublabel">
                      {{ item.subLabel }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="c-select__list__buttons">
            <c-button class="c-select__list__buttons-cancel" size="small" label="Отмена" @click="closeContainer" />
            <c-button v-if="multiple" size="small" label="Готово" color="primary" @click="selectMobileItems" />
          </div>
        </div>
      </div>

      <error-feedback v-if="error" :text="error" />
    </div>
  </div>
</template>

<script>
import Icon from "@/components/icon";
import Switcher from "@/components/controls/switcher";
import Button from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";
import { getUnique } from "@/utils/number/unique";

export default {
  name: "c-select",

  components: {
    "c-icon": Icon,
    "c-switcher": Switcher,
    "c-button": Button,
    ErrorFeedback,
  },

  props: [
    "value",
    "multiple",
    "label",
    "floatingLabel",
    "searchable",
    "clearable",
    "items",
    "placeholder",
    "reverse",
    "groups",
    "size",
    "reverseValue",
    "reverseType",
    "reverseTooltip",
    "required",
    "requiredMark",
    "useCustomColors",
    "checkbox",
    "checkboxType",
    "checkboxValue",
    "checkboxTooltip",
    "customOptions",
    "invalid",
    "error",
    "scrollToSelected",
  ],

  data() {
    return {
      localValue: null,

      query: "",

      container: false,

      localReverse: this.reverse,

      checkedMobileMultipleSelects: [],

      checkboxValueLocal: false,

      addedOptions: [],
    };
  },

  computed: {
    normalizedQuery() {
      return this.query.trim().toLowerCase();
    },

    emptyMessage() {
      return this.normalizedQuery ? "Совпадений не найдено" : "Справочник значений пустой";
    },

    fullList() {
      return [...this.items, ...this.addedOptions];
    },

    filteredList() {
      const list = this.fullList.filter((item) => {
        if (item && item.label) {
          const { label } = item;
          return label && `${label}`.toLowerCase().includes(this.normalizedQuery);
        }
      });

      return list;
    },

    filteredGroups() {
      let customOption = null;

      if (this.customOptions && this.normalizedQuery) {
        const exactMatch = this.filteredList.some((item) => item.label.toLowerCase() === this.normalizedQuery);
        if (!exactMatch) {
          customOption = {
            value: `custom-${getUnique()}`,
            label: this.query.trim(),
            custom: true,
          };
        }
      }

      if (!this.groups) {
        return [
          {
            id: "without-group",
            items: [...this.filteredList, customOption].filter(Boolean),
          },
        ].filter((group) => group.items.length);
      }

      const withoutGroup = this.filteredList.filter((item) => !item.group);

      return [
        ...this.groups.map((group) => {
          const { name } = group;
          const groupItems = this.filteredList.filter((item) => item.group === name);
          return {
            id: group.name,
            ...group,
            items: groupItems,
          };
        }),
        {
          items: [...withoutGroup, customOption].filter(Boolean),
        },
      ].filter((group) => group.items.length);
    },

    showSearch() {
      if (this.customOptions) return true;
      if (!this.searchable) return false;
      if (this.groups) return !!this.groups.length;
      return !!this.items.length;
    },
  },

  watch: {
    localReverse(value) {
      this.$emit("changeReverse", value, this.label);
    },

    reverse(value) {
      this.localReverse = value;
    },

    value(value) {
      this.localValue = value;
    },

    reverseValue(value) {
      this.localReverse = value;
    },

    localValue(value) {
      if (value) {
        const checked = Array.isArray(value) ? value : [value];
        const customChecked = checked.filter((i) => i.custom);

        // Удалить невыбранные
        const addedList = this.addedOptions.filter((option) =>
          customChecked.some((checked) => checked.value === option.value),
        );

        // Добавить новые
        this.addedOptions = [
          ...addedList,
          ...customChecked.filter((checked) => !addedList.some((option) => option.value === checked.value)),
        ];
      } else {
        this.addedOptions = [];
        this.localReverse = false;
      }

      this.$emit("input", value);
      this.checkedMobileMultipleSelects = value;
    },

    checkboxValue(value) {
      this.checkboxValueLocal = value;
    },

    checkboxValueLocal(value) {
      this.$emit("checkboxChange", value, this.label);
    },

    checkedMobileMultipleSelects(v) {
      if (v) {
        const checked = Array.isArray(v) ? v : [v];
        const customChecked = checked.filter((i) => i.custom);

        // Добавить новые

        this.addedOptions = [
          ...this.addedOptions,
          ...customChecked.filter((item) => !this.addedOptions.some((i) => i.value === item.value)),
        ];
      }
    },
  },

  created() {
    if (this.value) {
      this.localValue = this.value;
    }
  },

  methods: {
    clear() {
      if (!this.multiple) {
        this.$refs.input.blur();
        //this.$emit("input", null);
        //this.closeContainer();
      }
        //alert("5");
      this.localValue = null;
      this.addedOptions = [];
    },

    resetSearch() {
      this.query = "";
      this.$refs.searchInput.focus();
    },

    focus() {
      this.$refs.input.focus();
    },

    selectItem(item) {
      if (!this.multiple) {
        this.localValue = item;
        this.$emit("input", item);
      } else {
        if (!this.localValue) {
          this.localValue = [];
        }

        this.localValue.push(item);
        this.$emit("input", this.localValue);
        return;
      }

      this.container = false;
    },

    selectMobileItems() {
      if (!this.localValue) {
        this.localValue = [];
      }

      this.localValue = [...this.checkedMobileMultipleSelects];
      this.container = false;
      this.$emit("input", this.localValue);
    },

    isItemSelected(item) {
      if (this.multiple) {
        return this.localValue && this.localValue.some((v) => v.value === item.value);
      }

      if (!this.localValue) return false;
      return item.value === this.localValue.value;
    },

    isItemDisabled(item) {
      if (item.disabled) return true;
      
      if (this.localValue && this.multiple) {
        const result = this.localValue.findIndex((i) => item.label === i.label);

        return result !== -1;
      }
      return false;
    },

    dropItem(item) {
      this.localValue = this.localValue.filter((i) => i !== item);

      if (this.localValue.length === 0) {
        this.localValue = null;
      }

      this.container = false;
    },

    isArray(item) {
      return Array.isArray(item);
    },

    mousedownReverse(e) {
      e.preventDefault();
    },

    closeContainer() {
      this.container = false;
      if (this.multiple) {
        setTimeout(() => {
          this.checkedMobileMultipleSelects = [...(this.localValue || [])];
        }, 200);
      }
      document.removeEventListener('click', this.listenerHandler)
    },

    listenerHandler(e) {
      if (e.target.closest('.c-select') !== this.$refs.select) {
        this.closeContainer();
      }
    },

    openContainer() {
      if (this.multiple) {
        this.checkedMobileMultipleSelects = [...(this.localValue || [])];
      }
      this.query = "";
      this.container = true;

      this.$nextTick(() => {
        this.scrollToFirstSelectedItem();
      });
      
      document.addEventListener('click', this.listenerHandler)
    },

    scrollToFirstSelectedItem() {
      if (!this.scrollToSelected) return;
      const $container = this.$refs.list;
      if (!$container) return;

      const $selected = $container.querySelector(".c-select__item_selected");
      if ($selected) {
        const offset = $selected.offsetTop;
        $container.scrollTo(0, offset);
      }
    },

    getLabel(valueItem) {
      const item = this.fullList.find((i) => i.value.toString() === valueItem.value.toString());
      return item ? item.label : "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";

.c-select {
  &-floating-label {
    position: absolute;
    overflow: hidden !important;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    left: 0;
    font: 400 15px Fira Sans;
    pointer-events: none;
    line-height: 1.1;
    color: $color-label;
    padding-bottom: 10px;
    transition: all 200ms;
    padding-right: 15px;
    .c-input-label__required {
      visibility: visible;
    }
    .c-input-label-fullname {
      visibility: hidden;
      pointer-events: all;
    }

    &-active {
      font-size: 12px;
      //font-size: 80%;
      transform: translate3d(0, -100%, 0);
      white-space: normal;
      padding-right: 0;

      .c-input-label__required {
        visibility: visible;
      }
      .c-input-label-fullname {
        visibility: visible;
      }
    }
  }

  &-floating-label-not-visible {
    font: {
      size: 12px;
    }
    visibility: hidden;
    line-height: 13px;
    margin-bottom: 10px;
    color: $color-label;
  }
  &-checkbox {
    order: 4;

    &-type-icon {
      margin-left: auto;
    }
  }

  
  &-overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 300;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;

    @media screen and (max-width: 700px) {
      background: rgba(0, 0, 0, 0.7);
      transition: 0.2s;
    }

    &_active {
      visibility: visible;
      opacity: 1;
    }
  }

  &__wrapper {
    position: relative;

    &_with-label {
      .c-select {
        &__container {
          //top: 54px;
        }
      }
    }
  }

  &_size {
    &_small {
      .c-select {
        &_wrapper {
          // margin-bottom: -10px;
        }

        &__input {
          padding-bottom: 9px;
          min-height: 22px;
        }

        &__value {
          font-size: 13px;
          line-height: 13px;
          height: 13px;
          margin-top: 8px;
          margin-bottom: -1px;

          &_multiple {
            display: inline-flex;
            width: 100%;
            flex-wrap: wrap;
            min-height: 30px;
            height: auto;
            margin-bottom: -10px;
            margin-top: -5px;
            max-width: calc(100% - 30px);
          }
        }

        &__placeholder {
          font-size: 13px;
          line-height: 13px;
          height: 13px;
          margin-top: 8px;
          margin-bottom: -1px;
        }

        &__icon {
          cursor: pointer;
          margin-bottom: -5px;
          margin-top: 5px;
        }

        &__item {
          &-label {
            font-size: 13px;
          }
        }
      }
    }
  }

  &__label {
    font: {
      size: 12px;
    }
    line-height: 13px;
    margin-bottom: 10px;
    color: $color-label;
    &__required {
      color: red;
      margin-left: -4px;
    }
  }

  &__input {
    width: 100%;
    text-align: left;
    padding: 0;
    border: none;
    border-bottom: 1px solid $color-border;
    cursor: pointer;
    transition: 0.2s;
    background: none;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 17px;
    min-height: 30px;
    gap: 10px;

    &:focus {
      outline: none;
      border-bottom: 1px solid $color-primary;

      .c-select__icon {
        transform: rotate(180deg);
      }
    }

    &_required {
      border-bottom: 1px solid #ff238d;
    }

    &_empty {
      height: 31px;
    }
  }

  &-required {
    display: flex;
    position: absolute;
    bottom: -20px;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;

    & svg {
      min-height: 14px;
      min-width: 14px;
    }

    &_active {
      height: 14px;
      bottom: -22px;
      visibility: visible;
      opacity: 1;
    }

    &-text {
      white-space: nowrap;
      font-size: 11px;
      color: $color-secondary;
      line-height: 108%;
      margin-left: 6px;
      margin-top: 1px;
    }
  }

  &__placeholder {
    color: $color-label;
    font-size: 15px;
    line-height: 17px;
    position: absolute;
    z-index: 0;
    pointer-events: none;
    top: 0;
  }

  &__clear {
    margin-bottom: 10px;
    // margin-top: 2px;
    margin-top: -2px;
    margin-right: 5px;
    svg {
      fill: $color-secondary;
    }
    transition: 0.1s;
    opacity: 1;
    visibility: visible;

    &_hidden {
      display: none;
      opacity: 0;
      visibility: hidden;
    }
  }

  &__value {
    color: $color-font;
    font-size: 15px;
    line-height: 17px;
    min-height: 30px;
    flex-grow: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &_multiple {
      display: inline-flex;
      flex-grow: 1;
      flex-wrap: wrap;
      margin-top: -5px;
      min-height: 30px;
      height: auto;
      //margin-bottom: -13px;
      max-width: calc(100% - 30px);
    }

    &-item {
      border: 1px solid $color-button-border;
      min-height: 30px;
      margin-right: 5px;
      display: inline-flex;
      align-items: center;
      padding: 5px 14px;
      border-radius: 15px;
      transition: 0.2s;
      margin-bottom: 5px;
      white-space: normal;

      &:last-child {
        margin-right: 0;
      }

      &-label {
        font: {
          size: 12px;
          weight: 500;
        }
      }

      &-close {
        // padding-top: 2px;
        margin-left: 10px;

        svg {
          fill: $color-secondary;
          transition: 0.2s;
        }

        &:hover {
          svg {
            fill: $color-secondary-hover;
          }
        }
      }

      &:hover {
        border-color: $color-button-border-hover;
      }
    }
  }

  &__icon {
    width: 20px;
    height: 20px;
    transition: 0.2s;
    margin-bottom: 11px !important;
    margin-right: -4px !important;
  }

  &__container {
    position: absolute;
    width: 100%;
    left: 0;
    padding: 10px;
    background: white;
    box-shadow: $box-shadow;
    visibility: hidden;
    opacity: 0;
    //top: 30px;
    transition: 0.2s;
    border-radius: $border-radius-container;
    z-index: $z-index-container;

    @media screen and (max-width: 700px) {
      position: fixed;
      display: flex;
      flex-direction: column;
      width: calc(100% - 20px);
      height: calc(100% - 30px);
      border-radius: 6px;
      padding: 20px 15px;
      transform: translate(-50%, -50%);
      top: 50% !important;
      left: 50% !important;
      z-index: 1000;
    }

    &_active {
      visibility: visible !important;
      opacity: 1 !important;
    }
  }

  &__empty {
    color: $label;
    font-size: 15px;
    line-height: 1.2;
    padding: 5px 15px;
  }

  &__search {
    display: flex;
    align-items: flex-end;
    position: relative;
    width: calc(100% - 30px);

    padding: 10px 0 8px;
    margin: 0 15px 13px 15px;
    border-bottom: 1px solid $color-border;

    &-icon {
      margin-right: 10px;
      font-size: 0;
      margin-bottom: 2px;

      svg {
        stroke: $color-label;
        fill: none;
      }
    }

    &-input {
      border: none;
      height: 17px;
      font-size: 13px;
      flex: 1;
      width: inherit;

      &:focus {
        outline: none;
      }

      &::placeholder {
        font-style: italic;
        color: $color-label;
      }
    }

    &-clear {
      cursor: pointer;
      transition: 0.2s;
      margin-left: 5px;

      &_hidden {
        opacity: 0;
        visibility: hidden;
      }
    }
  }

  &__list {
    max-height: 200px;
    overflow-x: auto;

    @media screen and (max-width: 700px) {
      max-height: 100vh;
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
      background: white;
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
      width: 4px;
      border-radius: 2px;
    }

    &__buttons {
      display: none;

      @media screen and (max-width: 700px) {
        display: flex;
        margin-left: 10px;
        position: relative;
        margin-top: auto;
        padding-top: 12px;
        align-items: flex-end;

        & .c-button_size_small {
          padding: 8px 20px;
        }

        &-cancel {
          margin-right: 5px;
        }

        &:before {
          content: "";
          position: absolute;
          width: 100%;
          height: 25px;
          top: -20px;
          left: 0;
          background: linear-gradient(rgba(255, 255, 255, 0) 0, #ffffff 100%);
        }
      }
    }
  }

  &__item {
    padding: 0 15px;
    transition: 0.2s;
    border-radius: 15px;
    cursor: pointer;

    &__mobile {
      display: none;
      margin-left: 10px;
      height: 25px !important;

      & .c-switcher_checkbox .c-switcher-label {
        font-weight: normal;
        font-size: 15px;
        line-height: 190%;
      }

      @media screen and (max-width: 700px) {
        display: block;
      }
    }

    &__not__multiple__mobile {
      display: none;
      padding: 0 12px;
      transition: 0.2s;
      border-radius: 15px;
      cursor: pointer;
      //background: #E1EDFF;

      &-label {
        font-size: 15px;
        color: $color-font;
        line-height: 16px;
        padding: 7px 0;
      }

      &_disabled {
        //pointer-events: none;
        //background: #FFFFFF;
      }

      @media screen and (max-width: 700px) {
        display: block;
      }
    }

    @media screen and (max-width: 700px) {
      //display: none;
      //pointer-events: none;

      &__item &-label {
        pointer-events: none;
        display: none;
      }

      &__search {
        display: block;
      }
    }

    &:hover {
      background: $color-bg-hover;
    }

    &-label {
      font-size: 15px;
      color: $color-font;
      line-height: 16px;
      padding: 7px 0;
    }
    &-sublabel {
      color: $color-label;
      font-size: 11px;
      margin-top: 2px;
    }

    &_disabled {
      pointer-events: none;

      .c-select__item-label {
        color: $color-label;
      }
    }

    &_selected {
      pointer-events: none;

      .c-select__item-label {
        color: $color-label;
      }
    }
  }

  &__reverse {
    //width: 100px;
    //margin-bottom: -10px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &-switcher {
      flex-shrink: 0;
      color: rgba(0, 0, 0, 0.5);
    }
  }

  &__group {
    &-items {
      @media screen and (max-width: 700px) {
        display: none;
      }

      &-mobile {
        display: none;

        @media screen and (max-width: 700px) {
          display: block;
        }
      }
    }

    &:not([data-group="without-group"]) {
      margin: 10px 0;
      .c-select__item {
        padding-left: 24px;
      }
    }

    &-label {
      font-size: 15px;
      font-weight: 500;
      color: $color-label;
      margin-left: 10px;
      margin-bottom: 5px;

      @media screen and (max-width: 700px) {
        margin-bottom: 0;
        font-weight: 500;
        font-size: 15px;
        line-height: 190%;
      }
    }

    &_hidden {
      display: none;
    }
  }

  &.invalid {
    .c-select__input {
      border-bottom-color: $color-secondary;
    }
  }
}
</style>
